import { render, staticRenderFns } from "./DonorForm.vue?vue&type=template&id=9f88cc6a"
import script from "./DonorForm.vue?vue&type=script&lang=js"
export * from "./DonorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports